import { render, staticRenderFns } from "./LoyatlyStats.vue?vue&type=template&id=794840d3&"
import script from "./LoyatlyStats.vue?vue&type=script&lang=js&"
export * from "./LoyatlyStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports